<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">



    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
            <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.displayName }}</p>
      <small>{{ activeUserInfo.userRole }}</small>
    </div>
        <!-- <img v-if="activeUserInfo.photoURL" key="onlineImg" :src="activeUserInfo.photoURL" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" /> -->
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/user/profile/' + user_id).catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user_id : null
    };
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    }
  },
  methods: {
    logout() {
      // if user is logged in via auth0
      if (this.$auth.profile) this.$auth.logOut();
      // If JWT login
      if (localStorage.getItem("accessToken")) {
        localStorage.removeItem("accessToken");


    localStorage.removeItem('enrich_master_account_website_field_columns')
    localStorage.removeItem('enrich_master_account_linkedin_field_columns')
    localStorage.removeItem('enrich_master_account_sic_code_field_columns')
    localStorage.removeItem('enrich_master_account_phone_field_columns')
    localStorage.removeItem('enrich_master_account_switchboard_field_columns')
    localStorage.removeItem('enrich_master_contact_job_title_field_columns')
    localStorage.removeItem('enrich_master_contact_email_field_columns')
    localStorage.removeItem('enrich_master_contact_mobile_field_columns')
    localStorage.removeItem('enrich_master_contact_ddi_field_columns')
    localStorage.removeItem('enrich_master_contact_role_field_columns')
    localStorage.removeItem('enrich_master_contact_sub_role_field_columns')
    localStorage.removeItem('enrich_master_contact_seniority_field_columns')
    localStorage.removeItem('enrich_master_contact_social_media_field_columns')
    localStorage.removeItem('enrich_master_account_core_field_columns')
    localStorage.removeItem('enrich_master_contact_core_field_columns')
    localStorage.removeItem('enrich_master_account_none_core_field_columns')
    localStorage.removeItem('enrich_master_account_none_core_field_ids')
    localStorage.removeItem('enrich_none_core_number_type_ids')
    localStorage.removeItem('view_campaign_data_reloaded')
    localStorage.removeItem('new_selected_account_ids_to_campaign')


    
    localStorage.removeItem('enrich_master_contact_none_core_field_columns')
    localStorage.removeItem('enrich_master_contact_none_core_field_ids')
    localStorage.removeItem('campaign_account_none_core_field_columns')
    localStorage.removeItem('campaign_account_none_core_field_ids')
    localStorage.removeItem('campaign_contact_none_core_field_columns')
    localStorage.removeItem('campaign_contact_none_core_field_ids')
    localStorage.removeItem('enrich_none_core_number_type_ids')


        this.$router.push("/login").catch(() => {});
        location.reload();

      }
      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change("public");
      localStorage.removeItem("userInfo");

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push("/login").catch(() => {});
    },
  },
  mounted() {
    let userDetails = JSON.parse(localStorage.getItem("userInfo"))
    this.user_id = userDetails.uid
  }
};
</script>
